<template>
    <div :class="[
    'header_unit',
     pageType === 'top' || 'manage' ? 'header_bg_white' : 'header_bg_blue'
     ]"
    >
        <div class="header_box">
            <div class="menu_left">
                <slot name="menu_left"></slot>
            </div>
            <div class="menu_center">
                <slot name="menu_center"></slot>
            </div>
            <div class="menu_help">
                <slot name="menu_help"></slot>
            </div>
            <div class="menu_right2">
                <slot name="menu_right"></slot>
            </div>
            <div class="menu_csv">
                <slot name="menu_csv"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MonthlyHeader',
        props: {
            pageType: {
                type: String,
                default: 'default',
            },
        }
    }
</script>
